import {
    CLEAR_SELECTED_COMMUNICATION,
    DELETE_COMMUNICATION_FAIL,
    DELETE_COMMUNICATION_SUCCESS,
    DISMISS_ERROR_ALERT,
    DISSOCIATE_EVENT_FAIL,
    DISSOCIATE_EVENT_SUCCESS,
    GET_COMMUNICATIONS_REPORT_DATA_FAILURE,
    GET_COMMUNICATIONS_REPORT_DATA_SUCCESS,
    GET_PAST_COMMUNICATIONS_SUCCESS,
    GET_SINGLE_COMMUNICATION_SUCCESS,
    POSTING_TO_API,
    SAVE_EVENT_ASSOCIATION_FAIL,
    SAVE_EVENT_ASSOCIATION_SUCCESS,
    SEND_COMMUNICATION_FAIL,
    SEND_COMMUNICATION_SUCCESS,
    SET_SELECTED_EVENT_ID
} from "../../actions/communications/communicationsAction";
import initialState from "./initialState";

export default function communicationsReducer(state = initialState, action) {

    switch (action.type) {

        case CLEAR_SELECTED_COMMUNICATION: {
            return {
                ...state,
                communicationSuccessfullyDeleted: null,
                communicationSuccessfullySent: null,
                selectedCommunication: null
            };
        }

        case DELETE_COMMUNICATION_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case DELETE_COMMUNICATION_SUCCESS: {
            return {
                ...state,
                communicationSuccessfullyDeleted: true,
                posting: false
            };
        }

        case DISMISS_ERROR_ALERT: {
            return {
                ...state,
                showErrorAlert: false,
            };
        }

        case DISSOCIATE_EVENT_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case DISSOCIATE_EVENT_SUCCESS: {
            return {
                ...state,
                selectedCommunication: {
                    ...state.selectedCommunication,
                    eventSuccessfullyDissociated: true,
                    associatedEvent: action.communication.associatedEvent
                },
                posting: false
            };
        }

        case GET_COMMUNICATIONS_REPORT_DATA_FAILURE: {
            return {
                ...state,
                showErrorAlert: true
            };
        }

        case GET_COMMUNICATIONS_REPORT_DATA_SUCCESS: {
            return {
                ...state,
                summaryReportData: action.summaryReportData,
                detailedReportData: action.detailedReportData
            };
        }

        case GET_PAST_COMMUNICATIONS_SUCCESS: {
            return {
                ...state,
                pastCommunications: action.pastCommunications
            };
        }

        case GET_SINGLE_COMMUNICATION_SUCCESS: {
            return {
                ...state,
                selectedCommunication: action.communication
            };
        }

        case POSTING_TO_API: {
            return {
                ...state,
                posting: true
            };
        }

        case SAVE_EVENT_ASSOCIATION_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case SAVE_EVENT_ASSOCIATION_SUCCESS: {
            return {
                ...state,
                selectedCommunication: {
                    ...state.selectedCommunication,
                    eventSuccessfullyAssociated: true,
                    selectedEventId: null,
                    associatedEvent: action.communication.associatedEvent
                },
                posting: false
            };
        }

        case SEND_COMMUNICATION_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case SEND_COMMUNICATION_SUCCESS: {
            return {
                ...state,
                communicationSuccessfullySent: true,
                posting: false
            };
        }

        case SET_SELECTED_EVENT_ID: {
            return {
                ...state,
                selectedCommunication: {
                    ...state.selectedCommunication,
                    selectedEventId: action.eventId
                }
            };
        }

        default: {
            return state;
        }
    }
}
